import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import './maintanace.css';
import comingsoon from './comingsoon.png';

const useStyles = makeStyles((theme) => ({
  
}));

export default function ServerMaintance() {
  
  return (
    <>
      <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Raleway:300,300i,400,400i,600,600i,700,700i" rel="stylesheet"/>
      <section id="hero">
    <div class="hero-container">
      <img src={comingsoon} />
      <h1>Site under maintenance</h1>
      <h2>We're working hard to improve our website </h2>
      <div class="countdown" data-count="2023/12/3" data-template="%d days %h:%m:%s"></div>
 
    </div>
  </section> 
    </>
  );
}
